import React, { FC } from 'react';

import Svg from './Svg';
import colors from '../../utils/colorConstants';

interface Props {
  width?: string;
  height?: string;
  strokeColor?: string;
  className?: string;
}

const Question: FC<Props> = ({
  className,
  height = '1.5rem',
  strokeColor = colors.lapel,
  width = '1.5rem',
}) => (
  <Svg
    className={className}
    height={height}
    title="question icon"
    viewBox="0 0 24 24"
    width={width}
  >
    <path
      clipRule="evenodd"
      d="m12 3c5 0 9 4 9 9s-4 9-9 9-9-4-9-9 4-9 9-9m0-1c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 14.4c-.4 0-.7.3-.7.7s.3.7.7.7.7-.3.7-.7c0-.4-.3-.7-.7-.7zm-.6-1.4v-.3c0-.7.4-1.4 1.4-2.3 1.2-1 1.4-1.5 1.4-2.5s-.8-1.8-2.1-1.8c-1.1 0-2.1.6-2.1 2 0 .2 0 .4.1.6l-1.1.2c-.1-.3-.2-.7-.2-1.1 0-1.5 1.3-2.9 3.3-2.9 2.1 0 3.4 1.2 3.4 2.8 0 1.3-.5 2.1-1.9 3.3-.6.6-.9 1-.9 1.9h-1.3z"
      fill={strokeColor}
      fillRule="evenodd"
    />
  </Svg>
);

export default Question;
